// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__PIwdk","checkboxInput":"Checkbox_checkboxInput__QOEih","checkboxInputColor":"Checkbox_checkboxInputColor__bddAd"};